import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { PropertyTypeGroupService } from '../proxy/planning/controllers/property-type-group.service';
// import { NextPropertyTypeService } from '../proxy/planning/controllers/next-property-type.service';

FieldBuilder.setNamespace('Planning');

export const PROPERTYTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.PropertyType.Name')
    .required()
    .minLength(1)
    .maxLength(40)
    .build(),
  FieldBuilder
    .text('code', 'Entity.PropertyType.Code')
    .required()
    .minLength(1)
    .maxLength(6)
    .build(),
  FieldBuilder
    .text('remsoftName', 'Entity.PropertyType.RemsoftName')
    .minLength(1)
    .maxLength(200)
    .build(),
  FieldBuilder
    .checkbox('isSapFicoApplied', 'Entity.PropertyType.IsSapFicoApplied')
    .build(),
  FieldBuilder
    .checkbox('isFOManagement', 'Entity.PropertyType.IsFOManagement')
    .build(),
  FieldBuilder.foreignKey(
    'propertyTypeGroupId',
    'Entity.PropertyTypeGroup',
    PropertyTypeGroupService
  )
    .displayFromNested('propertyTypeGroup.name')
    .sortBy('propertyTypeGroup.name')
    .build(),
  // FieldBuilder.foreignKey(
  //   'nextPropertyTypeId',
  //   'Entity.NextPropertyType',
  //   NextPropertyTypeService
  // )
  //   .displayFromNested('nextPropertyType.name')
  //   .sortBy('nextPropertyType.name')
  //   .build(),
];

export const PROPERTYTYPE_CONFIG = {
  entityName: 'PropertyType',
  localizationKey: 'Planning::Entity.PropertyType',
  fields: PROPERTYTYPE_FIELDS,
  permission: 'ControllingContract.PropertyTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
